import React from 'react'
import { View, StyleSheet, TouchableOpacity } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Icon, Text, NotifBadge } from '@components'
import { useScreen } from '@hooks'
import { useNavigationState } from '@react-navigation/native'
import { getActiveRouteNameChain } from '../navigationUtils'

interface WebMenuItemProps {
  id: string
  title: string
  icon: string
  screen: string
  isCollapsed: boolean
  onPress: (screen: string, navigator?: 'Tab' | 'Menu') => void
  badgeCount?: number
}

export const WebMenuItem: React.FC<WebMenuItemProps> = ({
  id,
  title,
  icon,
  screen,
  isCollapsed,
  onPress,
  badgeCount = 0
}) => {
  const theme = useTheme()
  const { isMobile } = useScreen()
  const routeNameChain = useNavigationState(state => getActiveRouteNameChain(state))
  
  // Active if the screen exists anywhere in the active route chain (supports deep links)
  const isActive = routeNameChain.includes(screen)
  const styles = getStyle(theme)

  return (
    <TouchableOpacity
      key={id}
      style={styles.menuItem}
      onPress={() => onPress(screen)}
      activeOpacity={0.7}
    >
      <View style={styles.menuItemContent}>
        <View style={styles.iconWrapper}>
          <Icon
            name={icon as any}
            size={18}
            color={isActive ? theme.colors.primary : theme.colors.text}
          />
          <NotifBadge total={badgeCount} testID={`menu-badge-${screen}`} />
        </View>
        {!isCollapsed && (
          <Text 
            type={isMobile ? "bodyExtraSmall" : "bodySmall"} 
            style={StyleSheet.flatten([styles.menuItemText, { color: isActive ? theme.colors.primary : theme.colors.text }] as any)}
          >
            {title}
          </Text>
        )}
      </View>
    </TouchableOpacity>
  )
}

const getStyle = (theme: Theme) => StyleSheet.create({
  menuItem: {
    marginHorizontal: theme.spacing.sm,
    borderRadius: 6,
  },
  menuItemContent: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: theme.spacing.md,
    paddingVertical: theme.spacing.md,
    gap: theme.spacing.sm,
  },
  iconWrapper: {
    position: 'relative',
  },
  menuItemText: {
    flex: 1,
    fontWeight: '400',
  },
})
